import React from 'react';
import './CpaPhoneInput.scss';
import PropTypes from 'prop-types';
import { Input } from '@thd-olt-component-react/input';
import { phoneRegex } from '@thd-olt-functional/utils';
import { validate } from '../../constants/constants';

const unformatPhone = (text) => {
  let newValue = text.replace(/\D/g, '');
  if (newValue.length > 10) {
    newValue = newValue.slice(0, -1);
  }
  return newValue;
};

const handleValidation = (text) => {
  let newValue = unformatPhone(text);
  return (validate(newValue, phoneRegex) || newValue.trim() === '')
    && (!newValue.startsWith('0') && !newValue.startsWith('1'));
};

function handleChange(event, callback) {
  let valid = handleValidation(event);

  callback(unformatPhone(event), 'phone', valid);
  return valid;
}

function formatPhone(value) {
  if (!value) {
    return '';
  }

  let format = unformatPhone(value).match(/(.{0,3})(.{0,3})(.{0,4})/);
  return !format[2] ? format[1] : '(' + format[1] + ') ' + format[2] + (format[3] ? '-' + format[3] : '');
}

const CpaPhoneInput = (props) => {
  const {
    header, value, callback
  } = props;
  return (
    <div className="cpa-phone-input">
      <Input
        name="phone"
        header={header}
        className="cpa-form-input"
        errorText="Please enter a valid phone number."
        placeholder="(___) ___-____"
        value={formatPhone(value)}
        onChange={(event) => handleChange(event, callback)}
        validation={handleValidation}
      />
    </div>
  );
};

CpaPhoneInput.propTypes = {
  callback: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

CpaPhoneInput.displayName = 'CpaPhoneInput';
export { CpaPhoneInput };
